const BASE_API_URL = "https://server.tradebid.click";
// const BASE_API_URL = "http://localhost:8080";

const BASE_DOMAIN = "https://tradebid.click";
// const BASE_DOMAIN = "http://localhost:6969";

const RECAPTCHA_SITE_KEY = "6LcauoIsAAAAAA-m4NF4XraF7rz_DERDdC0DoBcI";

export { BASE_API_URL, BASE_DOMAIN, RECAPTCHA_SITE_KEY };